// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__lwM41","notes":"Notes_notes__3SqpV"};